import * as angular from "angular";

export class VoterFileService {
    private readonly root: string;
    private readonly v2Root = "/v2/voterfile";
    private readonly $http: any;

    constructor($http: any, __env: any) {
        this.$http = $http;
        this.root = __env.apiUrl() + "/voterfile";
    }

    all(): Promise<object> {
        return this.$http.get(this.root);
    }

    user_registers(data: any): Promise<object> {
        return this.$http.get(this.root, data);
    }

    info(data: any): Promise<object> {
        return this.$http.get(this.root + "/" + data.id);
    }

    getColumnsData(id: any): Promise<object> {
        return this.$http.get(this.root + "/columns_data/" + id);
    }

    data(data: any): Promise<object> {
        return this.$http.get(this.root + "/data/" + data.id);
    }

    columns(): Promise<object> {
        return this.$http.get(this.root + "/columns");
    }

    getCampaignColumnValues(data: any): Promise<object> {
        return this.$http.get(
            this.root + "/campaign_column_values/" + data.id,
            { params: data }
        );
    }

    import(data: any): Promise<object> {
        return this.$http.post(this.root + "/import/" + data.erid, data);
    }

    insert(data: any): Promise<object> {
        return this.$http.post(this.v2Root + "/insert/" + data.id, data);
    }

    leaderImportProgress(data: any): Promise<object> {
        return this.$http.get(this.v2Root + "/leader/progress/" + data.id);
    }

    create(data: any): Promise<object> {
        return this.$http.post(this.root, data);
    }

    check(data: any): Promise<object> {
        return this.$http.post(this.root + "/check/" + data.erid, data);
    }

    conflicts(): Promise<object> {
        return this.$http.get(this.root + "/conflicts");
    }

    conflict_matches(): Promise<object> {
        return this.$http.get(this.root + "/conflict_matches");
    }

    stats(data?: any): Promise<object> {
        const erid = data ? "/" + data.id : "";
        return this.$http.get(this.root + "/stats" + erid);
    }

    add_voter(data: any): Promise<object> {
        return this.$http.post(this.root + "/add_voter", data);
    }

    replace_voter(data: any): Promise<object> {
        return this.$http.post(this.root + "/replace_voter", data);
    }

    delete_conflict(data: any): Promise<object> {
        return this.$http.delete(this.root + "/delete_conflict", data);
    }

    delete_all_conflicts(data: any): Promise<object> {
        return this.$http.delete(this.root + "/delete_all_conflicts", data);
    }

    count_conflicts(): Promise<object> {
        return this.$http.get(this.root + "/count_conflicts");
    }

    import_url(data: any): Promise<object> {
        return this.$http.post(this.v2Root + "/import_url", data);
    }

    token_info(data?: any): Promise<object> {
        return this.$http.get(this.v2Root + "/token_info", { params: data });
    }
    importInfo(data: any): Promise<object> {
        return this.$http.get(this.v2Root + "/import/" + data.id);
    }
    updateImport(data: any): Promise<object> {
        return this.$http.post(this.v2Root + "/import/" + data.imid, data);
    }
    skippedRows(data: any): Promise<object> {
        return this.$http.get(this.v2Root + "/import/skipped/" + data.id, {
            params: data,
        });
    }
    skippedRowsCount(data: any): Promise<object> {
        return this.$http.get(this.v2Root + "/import/skipped_count/" + data.id);
    }
    mapping(data: any): Promise<object> {
        return this.$http.get(this.v2Root + "/import/mapping/" + data.id);
    }
    delete(data: any): Promise<object> {
        return this.$http.delete(this.v2Root + "/import/" + data.id);
    }
}

angular.module("vcServices").service("VoterFileService", VoterFileService);
